import { CommonModule } from "@angular/common";
import { Component, Input, AfterViewInit, ViewChild, OnDestroy } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { MatOptionModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelect, MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TooltipModule } from "ngx-bootstrap/tooltip";

@Component({
    selector: "app-custom-dropdown",
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatOptionModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        TooltipModule,
    ],
    templateUrl: "./custom-dropdown.component.html",
    styleUrls: ["./custom-dropdown.component.scss"]
})
export class CustomDropdownComponent implements AfterViewInit, OnDestroy {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() tooltip: string;
  @Input() control: FormControl;
  @Input() searchControl: FormControl;
  @Input() data: any[] = [];
  @Input() multiple: boolean = false;
  @Input() searchable: boolean = true;
  @Input() displayProperty: string = "";
  @Input() valueProperty: string = "";
  @Input() isInvalid: boolean;
  @Input() errorMessage: string;
  @Input() hasAllOption: boolean = false;

  @ViewChild(MatSelect) matSelect!: MatSelect;

  private destroy$ = new Subject<void>();

  constructor() {}

  ngAfterViewInit(): void {
    if (this.searchable) {
      this.matSelect.openedChange.pipe(takeUntil(this.destroy$)).subscribe((opened) => {
        if (opened) {
          setTimeout(() => {
            const panel = this.matSelect.panel.nativeElement;
            const searchInput = panel.querySelector(".search-input") as HTMLInputElement;
            if (searchInput) {
              searchInput.focus();
            }
          }, 0);
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public clearSearch(event: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.searchControl.setValue("");
    if (this.matSelect.panelOpen) {
      setTimeout(() => {
        const panel = this.matSelect.panel.nativeElement;
        const searchInput = panel.querySelector(".search-input") as HTMLInputElement;
        if (searchInput) {
          searchInput.focus();
        }
      }, 0);
    }
  }

  public isString(item: any): boolean {
    return typeof item === "string";
  }
}
